import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../../_lib/ViewFetcher';
import { AccessLevelData } from '../../common/types';
import {
  AccessLevelInfoRequestForm,
  AccessLevelInfoRequestFormTypes,
} from '../../common/forms/AccessLevelInfoRequestForm';

export type CurrentAccessLevelEditViewProps = {
  currentAccessLevel: AccessLevelData;
  editApprovedRequestForm: AccessLevelInfoRequestFormTypes;
};

function CurrentAccessLevelEdit({ editApprovedRequestForm }: CurrentAccessLevelEditViewProps) {
  return <AccessLevelInfoRequestForm form={editApprovedRequestForm} />;
}

export const CurrentAccessLevelEditView = asFetchableView(CurrentAccessLevelEdit);
export type CurrentAccessLevelEditView = ComponentProps<typeof CurrentAccessLevelEditView>;
